import { apiRequest } from '@/common/utils/request.common'
import { normalizeBaseCategoryMain } from '@/common/normalize/normalize-base-category-main'
import { API_BASE_URL, HTTP_METHOD_GET } from '@/common/utils/request.const'

export const getCategory = async ({ category = '' }) => {
  try {
    const response = await apiRequest({
      url: `${API_BASE_URL}/v1/category/${category}`,
      method: HTTP_METHOD_GET,
    })

    response.data = normalizeBaseCategoryMain(response?.data?.data)

    return response
  } catch (e) {
    console.error('getCategory error', e.message)
  }
}
